"use client";

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery, useQueryClient } from "@tanstack/react-query";
//import Carousel from "../Carousel";
import { URL_API } from "../../../config/default";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import AlojamientoPlaceholder from "../Spinner/AlojamientoPlaceholder";
import Error from "../../../pages/Error/Index";
import { CustomToast } from "../../../utils/custom-toast";
import { myHeaders } from "../../../config/axios";

import AccommodationCard from "../Accommodation-card";
import { Link } from "react-router-dom";

import { chunkArray } from "../../../utils/chunkArray";
import { SliderChunk } from "./slider-section";
import useMedia from "../../../hooks/useMedia";

export default function FeaturedDestinations({ user, favoritos }: any) {
  const isMobile = useMedia("(max-width: 768px)", false);
  const queryClient = useQueryClient();

  const { isPending, error, data } = useQuery({
    queryKey: ["alquiler-destacados"],
    queryFn: () => {
      return fetch(`${URL_API}/properties?highlight=1&per_page=50`).then((res) =>
        res.json()
      );
    },
  });

  if (isPending)
    return (
      <section className="mx-auto px-0 sm:px-[150px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 ">
          {[1, 2, 3, 4].map((index) => {
            return <AlojamientoPlaceholder key={index} />;
          })}
        </div>
      </section>
    );

  if (error) return <Error />;


  const shuffle = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Intercambiar elementos
    }

    return array;
  };

  const setFavorito = (property: any, favoritos: any) => {
    let check = favoritos.data.filter((f: any) => f.property_id == property.id);
    if (check.length > 0) {
      const requestOptions = {
        method: "DELETE",
        headers: {
          Authorization: myHeaders,
        },
      };

      fetch(`${URL_API}/favorites/${check[0].id}`, requestOptions)
        .then(async (response) => {
          await response.json();
          return CustomToast({
            status: 200,
            msg: "",
            title: "Alojamiento eliminado de favoritos",
          });
        })
        .catch((error) => console.error(error));

      queryClient.invalidateQueries({
        queryKey: ["favoritos"],
      });
    } else {
      let formData = new FormData();
      formData.append("property_id", String(property.id));

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: myHeaders,
        },
      };

      fetch(`${URL_API}/favorites`, requestOptions)
        .then(async (response) => {
          if (response.ok) {
            await response.json();
            return CustomToast({
              status: 200,
              msg: "",
              title: "Alojamiento agregado a favoritos",
            });
          } else {
            return CustomToast({
              status: 400,
              msg: "",
              title: "Debes inicisar sesion para generar una lista de favoritos",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });


      queryClient.invalidateQueries({
        queryKey: ["favoritos"],
      });
    }


  };


  const chunkSize = isMobile ? 4 : 6;
  const destinations : any = shuffle(data.data);
  const chunkedDestinations = chunkArray(destinations, chunkSize);

  return (
    <section className="mx-auto px-0 sm:px-[150px]">
      <div className="text-center mb-8">
        <Link to="/alojamientos">
          <h2 className="text-sm sm:text-3xl font-bold text-[#8B9456] mb-2">
            Destinos destacados
          </h2>
        </Link>
        <p className="text-sm sm:text-lg text-gray-600">
          Los lugares más populares para tu próxima escapada
        </p>
      </div>


      {chunkedDestinations.map((chunk, idx) => (
        <SliderChunk
          key={idx}
          items={chunk}
          renderCard={(destination) => (
            <AccommodationCard
              destination={destination}
              setFavorito={setFavorito}
              favoritos={favoritos}
              user={user}
            />
          )}
        />
      ))}
    </section>
  );
}
